/**
 * "Esta mensagem conta como sendo de outra pessoa?"
 *
 * O Chat Interno decide varias coisas por autoria — badge de nao-lidas, som,
 * mark-read automatico — e todas usavam `senderId === currentUserId` direto.
 * Aviso automatico quebra essa equacao: ele precisa ser assinado por alguem que
 * seja MEMBRO do canal, e o escolhido costuma ser a conta de quem opera. Pra
 * essa pessoa o alerta parecia mensagem propria: chegava sem badge e sem som.
 *
 * Existe como funcao unica de proposito. A regra estava repetida em 4 lugares e
 * o fix anterior corrigiu o backend em dois pontos sem alcancar nenhum deles —
 * o front seguiu escondendo o aviso de quem o assinou (achado do gatekeeper,
 * 26/08). Centralizado, o proximo lugar que precisar da regra herda o acerto.
 */
export function ehDeOutro(
  msg: { senderId?: string | null; isSystem?: boolean } | null | undefined,
  currentUserId: string | null | undefined,
): boolean {
  if (!msg?.senderId) return false;
  // aviso do sistema conta pra todo mundo, inclusive pra quem consta como autor
  if (msg.isSystem) return true;
  return msg.senderId !== currentUserId;
}

/**
 * "Devo marcar o canal como lido agora?"
 *
 * So quando a mensagem conta como de outro E chegou no canal que esta aberto
 * na tela E a aba esta na frente — ou seja, a pessoa esta de fato olhando.
 *
 * Passou a valer para aviso do sistema junto com o resto, e essa e a mudanca
 * de comportamento: antes o aviso auto-assinado nao entrava aqui (a regra era
 * so `senderId !== currentUserId`, falsa nesse caso) e tambem nao contava como
 * nao-lido, entao dava no mesmo. Agora que ele CONTA, marcar a leitura e o que
 * evita um badge aceso para uma conversa que a pessoa esta lendo.
 */
export function deveMarcarLido(ctx: {
  msg: { senderId?: string | null; isSystem?: boolean } | null | undefined;
  currentUserId: string | null | undefined;
  noCanalAberto: boolean;
  janelaVisivel: boolean;
}): boolean {
  if (!ehDeOutro(ctx.msg, ctx.currentUserId)) return false;
  return ctx.noCanalAberto && ctx.janelaVisivel;
}
